import { styled } from '@mui/material/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Mui from 'materials';
import { Box, Grid, Typography } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  background: 'white',
  borderRadius: 8,
  minHeight: 150,
  padding: theme.spacing(4),
}));

const Text = styled(Typography)(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.common.black,
  marginTop: 4,
}));

type Props = {
  items: {
    title: string;
    text: string | React.ReactNode;
    icon?: React.ReactNode;
    planName?: string;
  }[];
};

const TopPerformance: React.FC<Props> = ({ items }) => {
  return (
    <Grid container spacing={4} pt={4}>
      {items.map((item, idx) => (
        <Grid key={idx} size={{ xs: 12, md: 4 }}>
          <StyledBox>
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography fontWeight={600} sx={{ color: 'black', textAlign: 'left' }}>
                <FormattedMessage id={`${item.title}`} />
              </Typography>
              <Box>{item.icon}</Box>
            </Box>
            <Text>
              <b>{item.planName} </b>
              <FormattedMessage id={`${item.text}`} />
            </Text>
          </StyledBox>
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(TopPerformance);
